import { guideSteps } from '@/mocks/home';
import { checklist } from '@/mocks/home';

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="mb-12 md:mb-16 max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-accent-700 mb-4">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-compasses-2-line" />
            </span>
            平替指引
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 leading-snug">
            找平替与新选择，按这四步走就行
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            把挑站点的过程变简单一点：先定条件，再横向对比，然后选索引最顺的那家，最后留个备选。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          <div className="flex flex-col">
            {guideSteps.map((step) => (
              <div key={step.id} className="flex gap-5 pb-8 last:pb-0">
                <div className="flex flex-col items-center">
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-heading text-sm">
                    {step.no}
                  </span>
                  <span className="flex-1 w-px bg-background-300/70 mt-2" />
                </div>
                <div className="pb-2">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{step.summary}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="rounded-lg border border-background-200/80 bg-background-50 p-6 md:p-8 h-fit">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                <i className="ri-checkbox-multiple-line text-lg" />
              </span>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                换一家之前的检查清单
              </h3>
            </div>
            <ul className="flex flex-col gap-4">
              {checklist.map((ck) => (
                <li key={ck.id} className="flex items-start gap-3">
                  <span className="w-5 h-5 shrink-0 mt-0.5 flex items-center justify-center text-accent-600">
                    <i className="ri-check-line text-base" />
                  </span>
                  <span className="text-sm text-foreground-700 leading-relaxed">{ck.text}</span>
                </li>
              ))}
            </ul>
            <a
              href="#subscribe"
              className="mt-8 inline-flex items-center justify-center gap-2 w-full px-5 py-3 rounded-md bg-secondary-500 text-background-50 dark:text-foreground-950 text-sm whitespace-nowrap hover:bg-secondary-600 transition-colors cursor-pointer"
            >
              订阅更新，之后就不用反复找了
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}